// 9fbef606107a605d69c0edbcd8029e5d
import logger from '@tcp/core/src/utils/loggerInstance';
import PRODUCTLISTINGPAGE_CONSTANTS from './ProductListing.constants';
import { DEFAULT_REDUCER_KEY, setCacheTTL } from '../../../../../utils/cache.util';

const initialState = {
  [DEFAULT_REDUCER_KEY]: null,
  essentialShopStep: 0,
  nextPageProducts: [],
  prevPageProducts: [],
};

// eslint-disable-next-line complexity
const ProductListingReducer = (state = initialState, action) => {
  switch (action.type) {
    case PRODUCTLISTINGPAGE_CONSTANTS.SET_PRODUCTS:
      return {
        ...state,
        loadedProductsPages: [...state.loadedProductsPages, action.payload.loadedProductsPages[0]],
        isFirstTimeLoad: false,
        totalProductsCount: action.payload.totalProductsCount,
      };

    case PRODUCTLISTINGPAGE_CONSTANTS.APPEND_PRODUCTS:
      return {
        ...state,
        loadedProductsPages: [
          [...state.loadedProductsPages[0], ...action.payload.loadedProductsPages[0]],
        ],
        isFirstTimeLoad: false,
        totalProductsCount: action.payload.totalProductsCount,
      };

    case PRODUCTLISTINGPAGE_CONSTANTS.SET_CURRENT_CATEGORY_ID:
      return {
        ...state,
        currentCategoryId: action.payload,
      };

    case PRODUCTLISTINGPAGE_CONSTANTS.SET_FIRST_PRODUCTS_PAGE:
      return {
        ...state,
        ...action.productsPage,
        [DEFAULT_REDUCER_KEY]: setCacheTTL(),
        isFirstTimeLoad: true,
        ssr: true,
      };
    case PRODUCTLISTINGPAGE_CONSTANTS.SET_PLP_LOADING_STATE:
      return action.payload.isLoadingMore !== state.isLoadingMore
        ? { ...state, ...action.payload }
        : state;
    case PRODUCTLISTINGPAGE_CONSTANTS.UNSET_PLP_BREADCRUMB:
      return { ...state, ...action.payload };
    case PRODUCTLISTINGPAGE_CONSTANTS.SET_WISHLIST_ITEMS:
    case PRODUCTLISTINGPAGE_CONSTANTS.RESET_PRODUCTS:
      return initialState;
    case PRODUCTLISTINGPAGE_CONSTANTS.SET_FILTER:
      return { ...state, ...{ selectedFilter: action.payload } };
    case PRODUCTLISTINGPAGE_CONSTANTS.SET_ADD_TO_FAVORITE: {
      if (state.loadedProductsPages) {
        return {
          ...state,
          loadedProductsPages: state.loadedProductsPages.map((products) => {
            return products.map((product) => {
              return product.miscInfo &&
                product.productInfo?.generalProductId === action.payload.colorProductId
                ? {
                    ...product,
                    miscInfo: {
                      ...product.miscInfo,
                      isInDefaultWishlist: true,
                      newItemId: action.payload.res?.newItemId,
                      favoritedCount: action.payload.res?.favoritedCount,
                    },
                  }
                : product;
            });
          }),
        };
      }
      return { ...state };
    }
    case PRODUCTLISTINGPAGE_CONSTANTS.SET_FIRST_PRODUCTS_PAGE_SSR:
      return {
        ...state,
        ...action.payload,
        [DEFAULT_REDUCER_KEY]: setCacheTTL(),
        isFirstTimeLoad: true,
        ssr: true,
      };
    case PRODUCTLISTINGPAGE_CONSTANTS.CATEGORY_NAVIGATION_INFO:
      return {
        ...state,
        categoryNavigationInfo: action.payload,
      };
    case PRODUCTLISTINGPAGE_CONSTANTS.ESSENTIAL_SHOP_STEP:
      return {
        ...state,
        essentialShopStep: action.payload,
      };
    case PRODUCTLISTINGPAGE_CONSTANTS.SET_CATEGORY_PAGE_SEO_DATA: {
      try {
        const {
          payload: {
            response: {
              categorySeoData: {
                seoTitle = '',
                seoMetaDesc = '',
                canonicalUrl = '',
                longDescription = '',
              } = {},
            } = {},
          } = {},
        } = action;
        return {
          ...state,
          seoTitle,
          seoMetaDesc,
          canonicalUrl,
          longDescription,
        };
      } catch (e) {
        logger.error({
          error: `ProductListing.reducer.js | SET_CATEGORY_PAGE_SEO_DATA | ${e}`,
          extradata: {
            methodName: 'PRODUCTLISTINGPAGE_CONSTANTS.SET_CATEGORY_PAGE_SEO_DATA',
          },
        });
        return state;
      }
    }
    case PRODUCTLISTINGPAGE_CONSTANTS.SET_PLP_SCROLL_STATE: {
      return {
        ...state,
        shouldPlpScroll: action.payload,
      };
    }
    case PRODUCTLISTINGPAGE_CONSTANTS.SET_DEVICE_TIER: {
      return {
        ...state,
        deviceTier: action.payload,
      };
    }
    case PRODUCTLISTINGPAGE_CONSTANTS.SET_BOPIS_FILTER_STATE: {
      return {
        ...state,
        isBopisFilterOn: action.payload,
      };
    }
    case PRODUCTLISTINGPAGE_CONSTANTS.SET_IS_SEARCH_PAGE_ACTIVE:
      return {
        ...state,
        isSearchPageActive: action.payload,
      };
    default: {
      return state;
    }
  }
};

export default ProductListingReducer;
